const ExtXrn = {
    fields: [
        "ulice",
        "orientacnicislo",
        "domovnicislo",
        "obec",
        "castobce",
        "mestskacast",
        "psc",
        "posta",
        "okres",
        "kodadresy"
    ],

    init: function(data, clearAddress, disableButton) {
        if (true !== data.hasOwnProperty("miniformId")
            || 6 !== parseInt(data["miniformId"])
            && 108 !== parseInt(data["miniformId"])
            && 262 !== parseInt(data["miniformId"])
        ) {
            return;
        }

        const adresa = $("#modal-adresa");
        if (!adresa.length) {
            return;
        }

        var _ch = $("#_ch");
        if (!_ch.length) {
            return;
        }

        adresa
            .off("keydown")
            .on("keydown", function() {
                ExtXrn.buttonSaveDisable(true);
                ExtXrn.clearFields();
            });

        if (true === clearAddress) {
            adresa.val("");
        }

        if (true === disableButton) {
            ExtXrn.buttonSaveDisable(true);
        }

        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax-advanced/xrn/autocomplete";

        adresa.autocomplete({
            autofocus: true,
            delay: 600,
            minLength: 3,
            global: false,
            type: "post",
            data: { "_ch": _ch.val() },
            source: function(request, response) {
                $.ajax({
                    url: url,
                    dataType: "json",
                    type: "post",
                    data: { "_ch": _ch.val(), "queryString": adresa.val() },
                    success: function(r) {
                        ExtXrn.buttonSaveDisable(true);
                        ExtXrn.clearFields();
                        if (r.hasOwnProperty("messages")) {
                            Lemo_Alert.addMany(r.messages);
                        }
                        if (r.hasOwnProperty("data")) {
                            if (r.data.length) {
                                response(r.data);
                            }
                        }
                    }
                });
            },
            response: function(e, ui) {
                if (ui.hasOwnProperty("content") && !ui.content.length) {
                    adresa.off("focus");
                }
            },
            select: function(e, ui) {
                e.preventDefault();

                if (ui.item === null) {
                    $(this).val("");
                    ExtXrn.clearFields();
                    ExtXrn.buttonSaveDisable(true);
                } else {
                    $(this).val(ui.item["label"]);
                    $(this).blur();
                    ExtXrn.fillFields(ui.item);
                    ExtXrn.buttonSaveDisable(false);
                }
            }
        });
    },

    fillFields: function(item) {
        $.each(ExtXrn.fields, function(i, field) {
            let element = $("#modal-" + field);
            if (element.length) {
                element.val(item[field]);
            }
        });
    },

    clearFields: function() {
        $.each(ExtXrn.fields, function(i, field) {
            let element = $("#modal-" + field);
            if (element.length) {
                element.val("");
            }
        });
    },

    buttonSaveDisable: function(disabled) {
        const kodadresy = $("#modal-kodadresy");
        const buttonSave = $("#dialogButtons").find("button.btn.btn-primary");
        let doNotCheck = false;
        if (typeof kodadresy.data("do-not-check") !== "undefined") {
            doNotCheck = true;
        }

        if (true === doNotCheck) {
            buttonSave.attr("disabled", false).prop("disabled", false);
        } else {
            buttonSave.attr("disabled", disabled).prop("disabled", disabled);
        }
    }
};

$(document).ready(function() {
    $(document)
        .on("modal.miniform.item.add.build", function(e, data) {
            ExtXrn.init(data, true, true);
        })
        .on("modal.miniform.item.add.error", function(e, data) {
            ExtXrn.init(data, false, false);
        })
        .on("modal.miniform.item.edit.build", function(e, data) {
            ExtXrn.init(data, true, true);
        })
        .on("modal.miniform.item.edit.error", function(e, data) {
            ExtXrn.init(data, false, false);
        });
});
